/* eslint-disable no-console */
/* eslint-disable @typescript-eslint/no-explicit-any */
export type ConsoleType = {
  log: (msg: any) => void;
  debug: (msg: any) => void;
  error: (msg: any) => void;
  warn: (msg: any) => void;
  info: (msg: any) => void;
};

export const LOG_LEVEL = {
  RUN: 0,
  ERROR: 1,
  WARN: 2,
  LOG: 3,
  INFO: 4,
  DEBUG: 5,
  FULL: 5,
};

const getConsole = (
  logLevel: typeof LOG_LEVEL[keyof typeof LOG_LEVEL]
): ConsoleType => {
  return {
    debug: msg => logLevel >= LOG_LEVEL.DEBUG && console.debug(msg),
    error: msg => logLevel >= LOG_LEVEL.ERROR && console.error(msg),
    info: msg => logLevel >= LOG_LEVEL.INFO && console.info(msg),
    log: msg => logLevel >= LOG_LEVEL.LOG && console.log(msg),
    warn: msg => logLevel >= LOG_LEVEL.WARN && console.warn(msg),
  };
};

export const Console = getConsole(
  process.env.NODE_ENV === 'production' ? LOG_LEVEL.RUN : LOG_LEVEL.FULL
);
